<template>
    <div class="marketing-text" :style="customStyle" @click="trackSelect">{{text}}</div>
</template>

<script>
import trackExposeMixin from '../mixin/track-expose';

export default {
    name: 'marketing-text',
    componentName: 'marketingText',
    mixins: [trackExposeMixin],
    props: {
        customStyle: String,
        text: String,
        trackSelectAction: Function
    },
    methods: {
        trackSelect() {
            if (this.trackSelectAction) {
                this.trackSelectAction();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.marketing-text {
  display: flex;
  flex-direction: column;
}
</style>




// WEBPACK FOOTER //
// src/views/marketing/components/text.vue